import { Bus, CalendarHeart, Phone, Sparkles, HeartHandshake } from "lucide-react";
import { useExperience } from "@/context/ExperienceContext";
import { cn } from "@/lib/utils";

export const CTA = {
  eligibility: { label: "Check Eligibility", icon: null, cls: "rrb-btn-primary", modal: "eligibility" },
  enroll: { label: "Enroll Now", icon: HeartHandshake, cls: "rrb-btn-green", modal: "enroll" },
  tour: { label: "Schedule a Tour", icon: CalendarHeart, cls: "rrb-btn-sky", modal: "tour" },
  call: { label: "Call Now", icon: Phone, cls: "rrb-btn-navy", modal: "call" },
  transportation: { label: "Transportation", icon: Bus, cls: "rrb-btn-purple", modal: "transportation" },
};

export function CtaButton({ kind, size = "md", tone = "primary", className, testId, onClick }) {
  const { open } = useExperience();
  const c = CTA[kind];
  const Icon = c.icon;
  return (
    <button
      type="button"
      data-testid={testId || `cta-${kind}-btn`}
      data-kind={kind}
      data-tone={tone}
      onClick={onClick || (() => open(c.modal))}
      className={cn("rrb-btn", tone === "soft" ? "rrb-btn-soft" : c.cls, size === "lg" && "rrb-btn-lg", size === "sm" && "rrb-btn-sm", className)}
    >
      {kind === "eligibility" ? (
        <img src="/media/rrb-emblem-sm.png" alt="" className="rrb-btn-emblem" />
      ) : (
        Icon && <Icon className="h-4 w-4" strokeWidth={2.5} />
      )}
      <span>{c.label}</span>
      {kind === "eligibility" && size === "lg" && <Sparkles className="h-4 w-4" />}
    </button>
  );
}
